module.exports = __webpack_public_path__ + "img/en.4fd7a266.png";